import Api from "../../utils/api";
import Endpoints from "../../core/config/Endpoints";

class AuthService {
    async login(data) {
        const response = await Api.post(Endpoints.login, data, {
            "Content-Type": "application/json"
        });

        return response ?? null;
    }

    async refreshToken() {
        const token = localStorage.getItem("token");
        const response = await Api.get(Endpoints.refreshToken, {
            "Content-Type": "application/json",
            "Authorization": token || '',
        });

        return response ?? null;
    }

    async updateProfile(data) {
        const token = localStorage.getItem("token");
        if (token) {
            const response = await Api.patch(Endpoints.updateProfile, data, {
                "Content-Type": "application/json",
                "Authorization": token || '',
            });

            return response ?? null;
        }
        return null;
    }
}

export default AuthService;
